// If user prefers reduced motion turn off linear gradient animation on all SVG elements
const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

if (mediaQuery.matches) {
    const svgs = document.querySelectorAll('svg'); 

    Array.from(svgs).forEach((svg) => {
        if (svg && svg.pauseAnimations) {
            svg.pauseAnimations();
        }

    });
}